// 游戏分类Mock数据
export const categories = [
  {
    slug: 'dianzi-youxi',
    name: '电子游戏',
    description: '经典老虎机与电子游戏，丰富多样的主题和玩法，带来极致的游戏体验与丰厚奖励。',
    icon: 'ri-gamepad-line',
  },
  {
    slug: 'zhuo-you',
    name: '桌游',
    description: '经典扑克、百家乐、轮盘等桌面游戏，还原真实赌场体验，策略与运气的完美结合。',
    icon: 'ri-vip-crown-line',
  },
  {
    slug: 'jieji-youxi',
    name: '街机游戏',
    description: '怀旧街机风格游戏，简单易上手，快节奏高回报，重温经典街机厅的热血与激情。',
    icon: 'ri-game-line',
  },
  {
    slug: 'tiyu-jingcai',
    name: '体育竞技',
    description: '足球、篮球、网球等体育主题游戏，结合赛事激情与游戏乐趣，感受竞技体育的魅力。',
    icon: 'ri-football-line',
  },
  {
    slug: 'caipiao-youxi',
    name: '彩票游戏',
    description: '多种彩票玩法，开奖快速透明，玩法简单中奖率高，让幸运触手可及。',
    icon: 'ri-ticket-line',
  },
  {
    slug: 'xin-pin-tuijian',
    name: '新品推荐',
    description: '最新上线的热门游戏，抢先体验全新玩法与惊喜奖励，成为第一批玩家。',
    icon: 'ri-fire-line',
  },
];

// 热门游戏Mock数据
export const games = [
  {
    id: 1,
    slug: 'caishen-dao',
    name: '财神到',
    category: 'dianzi-youxi',
    categoryName: '电子游戏',
    rating: 9.8,
    players: 1285000,
    description: '经典中国风老虎机游戏，以财神为主题，拥有免费旋转、百搭符号和丰厚的累积奖池。高画质3D特效，带来沉浸式的游戏体验。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20God%20of%20Wealth%20slot%20machine%20game%20with%20golden%20coins%20and%20red%20lanterns%2C%20luxurious%20Chinese%20New%20Year%20theme%2C%20warm%20golden%20lighting%2C%20rich%20red%20and%20gold%20color%20scheme%2C%20professional%20gaming%20art%2C%20clean%20background&width=400&height=300&seq=game-caishen-dao&orientation=landscape',
    tags: ['热门', '高倍率', '累积奖池'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    slug: 'xingji-chuanqi',
    name: '星际传奇',
    category: 'dianzi-youxi',
    categoryName: '电子游戏',
    rating: 9.6,
    players: 986000,
    description: '科幻太空主题老虎机，炫酷的激光特效和未来感设计。多重奖励关卡，让每一次旋转都充满惊喜。',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20space%20themed%20slot%20game%20with%20galaxy%20and%20stars%2C%20futuristic%20neon%20effects%2C%20deep%20space%20background%2C%20vibrant%20lights%2C%20professional%20gaming%20design%2C%20clean%20composition&width=400&height=300&seq=game-xingji-chuanqi&orientation=landscape',
    tags: ['科幻', '多关卡', '高画质'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    slug: 'huangjin-chengbao',
    name: '黄金城堡',
    category: 'dianzi-youxi',
    categoryName: '电子游戏',
    rating: 9.5,
    players: 852000,
    description: '中世纪城堡主题游戏，探索神秘的古堡，寻找隐藏的宝藏。丰富的奖励机制和精美的视觉设计。',
    image: 'https://readdy.ai/api/search-image?query=Medieval%20castle%20themed%20slot%20game%20with%20golden%20treasure%20chests%20and%20crowns%2C%20warm%20torch%20lighting%2C%20stone%20castle%20walls%2C%20rich%20golden%20accents%2C%20luxurious%20medieval%20aesthetic%2C%20professional%20gaming%20art&width=400&height=300&seq=game-huangjin-chengbao&orientation=landscape',
    tags: ['探险', '宝藏', '高倍率'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    slug: 'maya-baozang',
    name: '玛雅宝藏',
    category: 'dianzi-youxi',
    categoryName: '电子游戏',
    rating: 9.4,
    players: 743000,
    description: '探索古老玛雅文明，解开金字塔的秘密。独特的轮盘机制和丰富的免费旋转奖励。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Mayan%20pyramid%20themed%20slot%20game%20with%20golden%20artifacts%2C%20jungle%20atmosphere%2C%20warm%20sunset%20lighting%2C%20stone%20temples%2C%20mysterious%20golden%20treasures%2C%20professional%20gaming%20design%2C%20clean%20composition&width=400&height=300&seq=game-maya-baozang&orientation=landscape',
    tags: ['冒险', '古代文明', '免费旋转'],
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    slug: 'haidao-dubao',
    name: '海盗夺宝',
    category: 'dianzi-youxi',
    categoryName: '电子游戏',
    rating: 9.3,
    players: 621000,
    description: '加勒比海盗风格游戏，扬帆起航寻找传说中的宝藏。独特的藏宝图奖励系统，刺激的海战特效。',
    image: 'https://readdy.ai/api/search-image?query=Pirate%20treasure%20themed%20slot%20game%20with%20golden%20doubloons%20and%20treasure%20maps%2C%20ship%20deck%20background%2C%20warm%20sunset%20ocean%20lighting%2C%20adventure%20aesthetic%2C%20professional%20gaming%20design&width=400&height=300&seq=game-haidao-dubao&orientation=landscape',
    tags: ['海盗', '冒险', '藏宝图'],
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    slug: 'longzhu-chuanqi',
    name: '龙珠传奇',
    category: 'dianzi-youxi',
    categoryName: '电子游戏',
    rating: 9.7,
    players: 1102000,
    description: '东方神龙主题游戏，收集七颗龙珠召唤神龙。精美的中国风画面和创新的游戏机制。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20dragon%20themed%20slot%20game%20with%20pearl%20orbs%20and%20golden%20dragons%2C%20mythical%20atmosphere%2C%20warm%20golden%20and%20jade%20green%20colors%2C%20traditional%20Chinese%20art%20style%2C%20professional%20gaming%20design&width=400&height=300&seq=game-longzhu-chuanqi&orientation=landscape',
    tags: ['中国风', '神龙', '高人气'],
    isHot: true,
    isNew: false,
  },
  {
    id: 7,
    slug: 'xingyun-52',
    name: '幸运52',
    category: 'jieji-youxi',
    categoryName: '街机游戏',
    rating: 9.2,
    players: 589000,
    description: '经典扑克牌匹配游戏，简单易上手，快速对决，高额奖励。纯粹的街机游戏乐趣。',
    image: 'https://readdy.ai/api/search-image?query=Classic%20card%20matching%20arcade%20game%20with%20playing%20cards%20and%20golden%20chips%2C%20retro%20arcade%20feel%2C%20warm%20ambient%20lighting%2C%20green%20felt%20texture%2C%20professional%20gaming%20design%2C%20clean%20composition&width=400&height=300&seq=game-xingyun-52&orientation=landscape',
    tags: ['经典', '快节奏', '高奖励'],
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    slug: 'baijiale-zhiwang',
    name: '百家乐之王',
    category: 'zhuo-you',
    categoryName: '桌游',
    rating: 9.6,
    players: 967000,
    description: '旗舰级百家乐游戏，真实还原赌场体验。多桌同玩，专业荷官，流畅的游戏节奏。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20baccarat%20table%20with%20elegant%20cards%20and%20golden%20chips%2C%20luxury%20casino%20setting%2C%20warm%20chandelier%20lighting%2C%20professional%20table%20game%20photography%2C%20rich%20dark%20background&width=400&height=300&seq=game-baijiale-zhiwang&orientation=landscape',
    tags: ['旗舰', '专业', '多桌'],
    isHot: true,
    isNew: false,
  },
];

// 文章Mock数据
export const articles = [
  {
    id: 1,
    slug: 'pg-dianzi-youxi-xinshou-gonglue',
    title: 'PG电子游戏新手入门完全攻略：从零到高手',
    excerpt: '刚接触PG电子游戏？这篇全面攻略带你了解游戏规则、技巧策略和资金管理，助你快速上手。',
    content: `
      <h2>PG电子游戏简介</h2>
      <p>PG电子游戏是全球领先的在线游戏平台，以其精美的画面、丰富的游戏内容和公平的游戏机制赢得了全球玩家的信赖。无论你是游戏新手还是资深玩家，PG游戏都能为你提供极致的游戏体验。</p>
      <h2>如何开始你的PG游戏之旅</h2>
      <p>首先，选择一个可靠的PG游戏平台进行注册。注册过程简单快捷，只需填写基本信息即可完成。注册后，你可以通过多种方式为账户充值，开始你的游戏之旅。</p>
      <h2>热门游戏推荐</h2>
      <p>对于新手玩家，我们推荐从经典的电子老虎机游戏开始，如"财神到"、"龙珠传奇"等热门游戏。这些游戏规则简单，画面精美，非常适合初学者熟悉游戏机制。</p>
      <h2>游戏技巧与策略</h2>
      <p>虽然电子游戏主要依靠运气，但掌握一些基本策略可以帮助你更好地管理资金，延长游戏时间。设定预算、合理分配投注金额、了解游戏的返还率（RTP）都是重要的技巧。</p>
      <h2>资金管理的重要性</h2>
      <p>良好的资金管理是长期享受游戏乐趣的关键。建议每次游戏前设定明确的预算上限，避免追逐损失。记住，游戏的目的首先是娱乐。</p>
      <h2>安全与责任游戏</h2>
      <p>PG游戏平台高度重视玩家安全，采用先进的加密技术保护用户信息和资金安全。同时，平台也倡导责任游戏理念，提供多种自我管理工具。</p>
    `,
    category: 'gonglue',
    categoryName: '游戏攻略',
    image: 'https://readdy.ai/api/search-image?query=Beginner%20guide%20concept%20with%20gaming%20controller%20and%20glowing%20elements%2C%20warm%20golden%20and%20red%20lighting%2C%20modern%20gaming%20aesthetic%2C%20dark%20elegant%20background%2C%20professional%20photography%2C%20clean%20composition&width=300&height=200&seq=article-xinshou-gonglue&orientation=landscape',
    author: 'PG游戏攻略组',
    date: '2026-08-01',
    readTime: '8分钟',
    tags: ['新手攻略', '入门指南', '游戏技巧'],
    isFeatured: true,
  },
  {
    id: 2,
    slug: 'caishindao-gaobeilv-jiqiao',
    title: '《财神到》高倍率技巧揭秘：老玩家都在用的策略',
    excerpt: '深入解析《财神到》游戏的高倍率触发机制，分享专业玩家的实战经验和获胜策略。',
    content: `
      <h2>《财神到》游戏特色</h2>
      <p>《财神到》是PG游戏平台最受欢迎的老虎机游戏之一，以中国传统财神文化为主题，融合了精美的3D画面和丰富的奖励机制。游戏拥有5个转轴和243条中奖线路。</p>
      <h2>了解游戏机制</h2>
      <p>要想在《财神到》中获得更好的游戏体验，首先需要了解游戏的基本机制。游戏中的百搭符号可以替代大部分其他符号，财神散落符号可以触发免费旋转回合。</p>
      <h2>免费旋转触发技巧</h2>
      <p>当转轴上出现3个或以上财神散落符号时，将触发免费旋转奖励。免费旋转期间，所有奖金将乘以特定的倍数，这是获取高额奖励的最佳时机。</p>
      <h2>累积奖池机制</h2>
      <p>《财神到》拥有丰厚的累积奖池，每次有玩家进行游戏时，奖池金额都会增加。触发累积奖池需要满足特定条件，通常是随机触发的惊喜奖励。</p>
      <h2>资金分配建议</h2>
      <p>建议将游戏资金分为多个小份，每次使用其中一份进行游戏。这样即使运气不佳，也能有足够的资金继续游戏，等待好运到来。</p>
      <h2>实战经验分享</h2>
      <p>根据资深玩家的经验，在游戏热度较高的时候（如节假日、平台活动期间），触发大奖的概率似乎更高。当然，这更多是一种经验之谈，游戏结果始终是随机的。</p>
    `,
    category: 'gonglue',
    categoryName: '游戏攻略',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20God%20of%20Wealth%20slot%20game%20detail%20with%20golden%20coins%20falling%2C%20red%20envelope%20theme%2C%20luxurious%20lighting%2C%20warm%20festive%20atmosphere%2C%20rich%20red%20and%20gold%20colors%2C%20professional%20gaming%20art&width=300&height=200&seq=article-caishen-dao&orientation=landscape',
    author: 'PG游戏攻略组',
    date: '2026-08-03',
    readTime: '10分钟',
    tags: ['财神到', '老虎机', '高倍率'],
    isFeatured: true,
  },
  {
    id: 3,
    slug: 'pg-youxi-xinpin-tuijian-2026',
    title: '2026年PG游戏新品推荐：十大必玩新游盘点',
    excerpt: 'PG平台最新上线的十款精品游戏深度评测，从画面、玩法、奖励机制全面分析。',
    content: `
      <h2>2026年PG新游戏概览</h2>
      <p>2026年，PG游戏平台持续推出多款精品新游戏，涵盖电子老虎机、街机、桌游等多个品类。我们精选了十款最值得体验的新游戏，为你带来详细评测。</p>
      <h2>玛雅宝藏 - 年度最受期待新游</h2>
      <p>《玛雅宝藏》以神秘的玛雅文明为背景，采用了全新的金字塔轮盘机制。画面精美，配乐震撼，是今年不容错过的佳作。</p>
      <h2>海盗夺宝 - 冒险主题新体验</h2>
      <p>《海盗夺宝》将玩家带入加勒比海盗的冒险世界，独特的藏宝图奖励系统让每次游戏都充满惊喜。海战特效尤为出色。</p>
      <h2>更多新品一览</h2>
      <p>除了这两款重磅新作，还有多款精品游戏值得关注。每款游戏都有独特的主题和创新的玩法机制，总有一款适合你。</p>
    `,
    category: 'tuijian',
    categoryName: '游戏推荐',
    image: 'https://readdy.ai/api/search-image?query=New%20game%20collection%20display%20with%20various%20game%20icons%20and%20screenshots%2C%20modern%20gaming%20showcase%2C%20warm%20golden%20lighting%2C%20dark%20elegant%20background%2C%20professional%20presentation%2C%20clean%20composition&width=300&height=200&seq=article-xinpin-tuijian&orientation=landscape',
    author: 'PG游戏评测组',
    date: '2026-08-05',
    readTime: '12分钟',
    tags: ['新品', '测评', '推荐'],
    isFeatured: true,
  },
  {
    id: 4,
    slug: 'baijiale-jiben-celue',
    title: '百家乐基本策略指南：提高胜率的实用方法',
    excerpt: '从规则入门到进阶策略，全面解析百家乐游戏的核心技巧，帮助玩家做出更明智的决策。',
    content: `
      <h2>百家乐游戏基础</h2>
      <p>百家乐是赌场中最受欢迎的桌面游戏之一，规则简单但充满策略性。游戏的目标是预测庄家或闲家哪一方的点数更接近9。</p>
      <h2>基本投注策略</h2>
      <p>在百家乐中，押注庄家的庄家优势最低，约为1.06%；押注闲家的庄家优势约为1.24%。建议新手从押注庄家开始。</p>
      <h2>资金管理技巧</h2>
      <p>设定每次游戏的投注上限，使用固定比例投注法可以有效控制风险。避免在连续输掉多局后加倍下注追逐损失。</p>
    `,
    category: 'gonglue',
    categoryName: '游戏攻略',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20baccarat%20strategy%20concept%20with%20playing%20cards%20spread%20on%20green%20felt%2C%20golden%20chips%2C%20warm%20ambient%20lighting%2C%20luxury%20casino%20atmosphere%2C%20professional%20photography&width=300&height=200&seq=article-baijiale-celue&orientation=landscape',
    author: 'PG游戏攻略组',
    date: '2026-08-06',
    readTime: '7分钟',
    tags: ['百家乐', '策略', '桌游'],
    isFeatured: false,
  },
  {
    id: 5,
    slug: 'pg-pingtai-anquan-baozhang',
    title: 'PG游戏平台安全保障体系全面解读',
    excerpt: '了解PG游戏平台的多重安全防护机制，包括数据加密、资金托管、公平性认证等核心保障。',
    content: `
      <h2>平台安全概述</h2>
      <p>PG游戏平台将玩家安全放在首位，建立了全方位的安全保障体系，确保每一位玩家都能在安全、公平的环境中享受游戏。</p>
      <h2>数据加密技术</h2>
      <p>平台采用银行级别的SSL加密技术，所有用户数据和交易信息都经过严格加密处理，确保信息传输安全。</p>
      <h2>资金安全保障</h2>
      <p>玩家资金采用独立托管机制，与平台运营资金完全分离。多重验证机制确保每一笔交易的真实性和安全性。</p>
      <h2>公平性认证</h2>
      <p>所有游戏均经过国际权威机构的随机性认证，游戏结果完全随机，确保公平公正的游戏环境。</p>
    `,
    category: 'zixun',
    categoryName: '平台资讯',
    image: 'https://readdy.ai/api/search-image?query=Digital%20security%20shield%20concept%20with%20lock%20icon%20and%20encryption%20visuals%2C%20modern%20technology%20aesthetic%2C%20warm%20golden%20glow%2C%20dark%20background%2C%20professional%20photography&width=300&height=200&seq=article-anquan-baozhang&orientation=landscape',
    author: 'PG游戏官方',
    date: '2026-08-07',
    readTime: '6分钟',
    tags: ['安全', '保障', '加密'],
    isFeatured: false,
  },
  {
    id: 6,
    slug: 'longzhu-chuanqi-wanfa-jiexi',
    title: '《龙珠传奇》玩法深度解析：召唤神龙的秘密',
    excerpt: 'PG平台热门游戏《龙珠传奇》完整攻略，从基础玩法到高级策略一网打尽。',
    content: `
      <h2>龙珠传奇概述</h2>
      <p>《龙珠传奇》是PG游戏平台最受欢迎的东方主题游戏之一，以收集七颗龙珠召唤神龙为核心玩法，融合了中国传统文化元素和现代游戏机制。</p>
      <h2>核心玩法机制</h2>
      <p>游戏中每颗龙珠代表一个特殊的奖励功能。收集到全部七颗龙珠后，将触发终极奖励——神龙降临，获得巨额奖金。</p>
      <h2>龙珠收集技巧</h2>
      <p>不同的龙珠有不同的出现概率和触发条件。建议玩家重点关注稀有龙珠的出现时机，在特定时段进行游戏可能提高收集效率。</p>
    `,
    category: 'gonglue',
    categoryName: '游戏攻略',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20dragon%20and%20glowing%20pearls%20slot%20game%20detail%2C%20mythical%20atmosphere%20with%20golden%20dragons%2C%20traditional%20Chinese%20elements%2C%20warm%20jade%20and%20gold%20colors%2C%20professional%20gaming%20art&width=300&height=200&seq=article-longzhu-chuanqi&orientation=landscape',
    author: 'PG游戏攻略组',
    date: '2026-08-08',
    readTime: '9分钟',
    tags: ['龙珠传奇', '深度解析', '神龙'],
    isFeatured: false,
  },
];

// 文章分类
export const articleCategories = [
  { slug: 'all', name: '全部文章' },
  { slug: 'gonglue', name: '游戏攻略' },
  { slug: 'tuijian', name: '游戏推荐' },
  { slug: 'zixun', name: '平台资讯' },
  { slug: 'huodong', name: '活动公告' },
];

// FAQ数据
export const faqs = [
  {
    question: 'PG游戏平台是否安全可靠？',
    answer: 'PG游戏平台采用国际领先的安全加密技术，所有玩家数据和资金交易均经过多重加密保护。平台持有正规运营牌照，接受第三方机构监管，确保公平公正的游戏环境。数百万玩家的信赖是我们最好的证明。',
  },
  {
    question: '如何注册PG游戏账号？',
    answer: '注册PG游戏账号非常简单。点击网站右上角的"注册"按钮，填写基本信息（用户名、密码、手机号或邮箱），完成手机或邮箱验证即可。整个注册过程仅需1-2分钟。',
  },
  {
    question: 'PG游戏支持哪些充值方式？',
    answer: 'PG游戏平台支持多种充值方式，包括银行卡转账、支付宝、微信支付、USDT数字货币等。充值即时到账，无任何手续费。最低充值金额灵活，满足不同玩家的需求。',
  },
  {
    question: '游戏是否公平？如何保证随机性？',
    answer: 'PG游戏平台所有游戏均采用国际认证的随机数生成器（RNG），游戏结果完全随机且不可预测。平台定期接受第三方权威机构的随机性检测和公平性认证，确保每位玩家享有公平的游戏体验。',
  },
  {
    question: '提现需要多长时间？',
    answer: 'PG游戏平台提供快速提现服务，大部分提现申请在提交后30分钟内处理完成。具体到账时间取决于所选的提现方式，银行卡转账通常1-2个工作日到账，数字货币提现通常在1小时内完成。',
  },
  {
    question: '遇到游戏问题如何联系客服？',
    answer: 'PG游戏平台提供7x24小时在线客服服务，你可以通过网站右下角的在线客服按钮、官方邮箱（support@pggame.com）或客服热线与我们联系。我们的专业客服团队将快速响应你的问题。',
  },
];

// 网站信息
export const siteInfo = {
  name: 'PG游戏官方平台',
  description: 'PG游戏是全球玩家热爱的顶级游戏平台，汇聚海量热门游戏资源，提供流畅体验、丰厚奖励与安全保障。',
  keywords: 'pg游戏,pg游戏官网,pg游戏下载,pg游戏平台,pg游戏大全,pg游戏攻略,pg电子游戏推荐',
  url: 'https://www.pggame-official.com',
  email: 'support@pggame.com',
  phone: '400-888-9999',
  address: '中国上海市浦东新区张江高科技园区',
  year: 2026,
};